export const DEFAULT_MENTION_OPTIONS = [
  'Excellent',
  'Très Honorable avec Félicitations du Jury',
  'Très Honorable',
  'Honorable',
  'Très Bien',
  'Bien',
  'Assez Bien',
  'Passable',
];

export const DEFAULT_TEMPLATE = {
  universityName: 'UNIVERSITE QUEENSLANDS',
  chairName: "CHAIRE INTERUNIVERSITAIRE D'ETHIQUE ET DE RECHERCHE HAÏTIANO-AFRICAINES",
  acronym: '(CIERHA)',
  address: 'Fort-Liberte, entree route Ferrier',
  web: 'www.cierha.net',
  email: 'info@cierha.net',
  leftLogoUrl: '',
  rightLogoUrl: '',
  documentTitle: 'CERTIFICATE',
  clause1:
    'Considering the Ministerial Decision of April 2, 2014 registering Queensland University and granting the license No. A-15-798;',
  clause2:
    'In accordance with the partnership between Queensland University and its sisters Universities under Ethos Universitas in Belgium;',
  clause3:
    'Considering the minutes of the Examining Committee attesting that the candidate has successfully completed the competency assessment required by law and regulations;',
  signatureLeftName: 'Prof. Jean Claude DORSAINVIL',
  signatureLeftTitle: 'President of the Board of Directors of Queensland University',
  signatureRightName: 'Prof Jean Baptiste Jean',
  signatureRightTitle: "Coodinateur Africain d´Ethos Universitas",
  awardTemplate:
    'The degree of DOCTOR in {{domaine}}, Specialization {{specialite}} is awarded to {{genre}} {{noms}} born in {{lieuNaissance}} on {{dateNaissance}}, for the academic year {{anneeAcademique}} with the specialization {{specialite}} and confers upon {{pronoun}} the degree of Doctor of Philosophy (Ph.D.) with mention: {{mention}} to be enjoyed with all the rights and privileges attached thereto.',
  dateLineTemplate: 'Done at {{lieuEmission}}, {{dateEmission}}',
  mentionOptions: DEFAULT_MENTION_OPTIONS,
};

export const mergeTemplate = (saved) => ({
  ...DEFAULT_TEMPLATE,
  ...saved,
  mentionOptions: saved?.mentionOptions?.length
    ? saved.mentionOptions
    : DEFAULT_MENTION_OPTIONS,
});
